<template>
  <vaiku-islaikymas />
  <susitikimas-su-vagnoriumi />
  <kasos-aparatai />
  <sausio-tryl />
  <preliminarioji-sutartis />
  <div class="navigation">
    <div class="prev-posts">
      <router-link to="/straipsniai/page/2"
        >Senesni įrašai »</router-link
      >
    </div>
  </div>
</template>

<script>
import PreliminariojiSutartis from './Articles/PreliminariojiSutartis.vue'
import VaikuIslaikymas from './Articles/VaikuIslaikymas.vue'
import SausioTryl from './Articles/SausioTryl.vue'
import KasosAparatai from './Articles/KasosAparatai.vue'
import SusitikimasSuVagnoriumi from './Articles/SusitikimasSuVagnoriumi.vue'
export default {
  components: {
    SusitikimasSuVagnoriumi,
    KasosAparatai,
    VaikuIslaikymas,
    SausioTryl,
    PreliminariojiSutartis
  }
}
</script>
